import { addDays } from 'date-fns'
import { observer } from 'mobx-react'
import { FC } from 'react'

import {
  ButtonGroup,
  DatePickerField,
  formatDate,
  HorizontalAlignment,
} from '@avantstay/backoffice-core'

import { FiltersProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'

import { CalendarContainer, CustomFilterDate } from './DateFilter.styles'

interface DueDateFilterProps extends FiltersProps {
  initialValue?: string
  onChange: (value?: string) => void
}

enum DueDateFilterTypes {
  nextDay = 'nextDay',
  nextWeek = 'nextWeek',
  nextMonth = 'nextMonth',
  today = 'today',
}

const calendarOptions = [
  {
    id: DueDateFilterTypes.today,
    value: `${formatDate(new Date())}_${formatDate(new Date())}`,
    title: 'Today',
  },
  {
    id: DueDateFilterTypes.nextDay,
    value: `${formatDate(addDays(new Date(), 1))}_${formatDate(addDays(new Date(), 1))}`,
    title: 'Next Day',
  },
  {
    id: DueDateFilterTypes.nextWeek,
    value: `${formatDate(addDays(new Date(), 1))}_${formatDate(addDays(new Date(), 7))}`,
    title: 'Next Week',
  },
  {
    id: DueDateFilterTypes.nextMonth,
    value: `${formatDate(addDays(new Date(), 1))}_${formatDate(addDays(new Date(), 30))}`,
    title: 'Next Month',
  },
  {
    id: 'custom-range',
    value: undefined,
    title: 'Custom range',
  },
]

const _DueDateFilter: FC<DueDateFilterProps> = props => {
  const { dueDate } = casesFiltersStore

  return (
    <CalendarContainer>
      <DatePickerField.Small
        placeholder="Due Date"
        horizontalAlignment={HorizontalAlignment.Right}
        shouldDisplayInput={false}
        dateValue={dueDate ?? ''}
        shouldUseDatePickerBase
        shouldAcceptEmptyDate
        onChange={(value: string) => {
          props.onChange(value)
        }}
        minRangeLength={0}
        customDatePickerHeaderComponent={
          <CustomFilterDate>
            <ButtonGroup
              currentSelection={
                calendarOptions?.find(option => option.value === dueDate)?.value ?? undefined
              }
              name="date-picker-custom-filter-select-due-date"
              onClick={value => props.onChange(value)}
              options={calendarOptions}
            />
          </CustomFilterDate>
        }
      />
    </CalendarContainer>
  )
}

export const DueDateFilter = observer(_DueDateFilter)
